import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import useVoyagerStore from '../../stores/useVoyagerStore';

const stromaComposer = {
  borderRadius: '12px',
  bgcolor: 'var(--sunk)',
  backgroundImage: 'none',
  borderColor: 'var(--line)',
  boxShadow: 'none',
  pl: 1.25,
  py: 0.75,
} as const;

const stromaSend = {
  width: 34,
  height: 34,
  borderRadius: '50%',
  color: 'var(--on-accent)',
  backgroundImage: 'linear-gradient(180deg, var(--accent-hi), var(--accent))',
  boxShadow: '0 6px 14px -6px var(--accent-glow)',
  '&:hover': { filter: 'brightness(1.06)' },
  '&.Mui-disabled': { color: 'var(--on-accent)', opacity: 0.45 },
} as const;

const WorkspaceComposer: React.FC = () => {
  const [text, setText] = useState('');
  const status = useVoyagerStore((s) => s.workspaceAgentStatus);
  const send = useVoyagerStore((s) => s.sendWorkspaceAgentQuery);
  const selectedPerspective = useVoyagerStore((s) => s.selectedPerspective);
  const disabled = !selectedPerspective || status === 'running';

  const onSubmit = async () => {
    const v = text.trim();
    if (!v || disabled) return;
    setText('');
    await send(v);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 0.5,
        px: 1,
        ...stromaComposer,
      }}
    >
      <TextField
        multiline
        maxRows={6}
        fullWidth
        variant="standard"
        placeholder={
          selectedPerspective
            ? 'Ask the agent… (e.g. "bookings by country last 30 days")'
            : 'Pick a perspective first'
        }
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={!selectedPerspective}
        InputProps={{ disableUnderline: true, sx: { fontSize: 13, py: 0.5 } }}
      />
      <IconButton
        size="small"
        color="primary"
        onClick={onSubmit}
        disabled={disabled || !text.trim()}
        aria-label="Send"
        sx={stromaSend}
      >
        <SendIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default WorkspaceComposer;
